module.exports = __webpack_public_path__ + "static/media/shop.5b049af2.png";